import { PartnerApp } from '../interfaces/partner';
import { OutlawCommunityConfig } from '../outlaw-community.config';
import { getCommunityFeatureFlags } from './feature-flag.generator';
import { getCommunityExternalApi } from './external-api.generator';
import { getCommunityLinks } from './links.generator';

export function buildCommunityConfig(config: Partial<OutlawCommunityConfig>): OutlawCommunityConfig {
  return {
    ...config,
    userId: config.userId || '',
    groupId: config.groupId || '',
    title: config.title || 'Community',
    name: config.name || 'community',
    menu: config.menu || [],
    currentApp: config.currentApp || PartnerApp.COMMUNITY,
    externalApi: getCommunityExternalApi(config),
    links: getCommunityLinks(config),
    featureFlags: getCommunityFeatureFlags(config),
    baseUrl: config.baseUrl || '/api',
  };
}
